import React from 'react';
import "../Components/About.css";
import "@fontsource/plus-jakarta-sans";

const About = () => {
  return (
    <div className="about-container d-flex align-items-center justify-content-center text-center text-white">
      <div className=" p-4 rounded">
      <h5 className="fs-55 fw-700 plus font-28">
            About-Us        </h5>
        <h5 className="plus fs-40 fw-700 font-22 hideinmo">
          We help businesses of every size – from<br/> entrepreneurs to iconic brands.
        </h5>
        <h5 className="plus fs-40 fw-700 font-22 hideindesktop">
          We help businesses of every size – from entrepreneurs to iconic brands.
        </h5>
        <p className="about-text">
          Klaviyo lets you deliver amazing experiences across email and other owned channels.
        </p> 
      </div>
    </div>
  );
};

export default About;
